import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import ChatPanel from './ChatPanel';
const ChatIcon = () => (React.createElement("svg", { fill: 'none', height: '20', viewBox: '0 0 24 24', width: '20', xmlns: 'http://www.w3.org/2000/svg' },
    React.createElement("path", { d: 'M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z', stroke: 'currentColor', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2' })));
const ChatOverlay = () => {
    const [panelOpen, setPanelOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const messages = useSelector((state) => state['features/chat'].messages);
    const reduxMode = useSelector((state) => state['features/base/config'].liveCoachingMode);
    const urlMode = new URLSearchParams(window.location.search).get('config.liveCoachingMode');
    const liveCoachingMode = reduxMode || urlMode;
    // Only count remote (non-local, non-reaction, non-system) messages for the unread badge
    const remoteCount = messages.filter((m) => m.messageType === 'remote' && !m.isReaction).length;
    const prevRemoteCountRef = useRef(remoteCount);
    useEffect(() => {
        if (remoteCount > prevRemoteCountRef.current && !panelOpen) {
            const delta = remoteCount - prevRemoteCountRef.current;
            console.log('[TBL-Chat] Nouveau(x) message(s) distant(s):', delta);
            setUnreadCount(c => c + delta);
        }
        prevRemoteCountRef.current = remoteCount;
    }, [remoteCount, panelOpen]);
    const handleOpen = () => {
        setPanelOpen(true);
        setUnreadCount(0);
    };
    const handleClose = () => {
        setPanelOpen(false);
    };
    console.log('[TBL-Chat] ChatOverlay render — liveCoachingMode:', liveCoachingMode);
    if (liveCoachingMode !== 'coach' && liveCoachingMode !== 'viewer') {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { "aria-label": 'Ouvrir le chat', onClick: handleOpen, style: {
                alignItems: 'center',
                backdropFilter: 'blur(8px)',
                background: 'rgba(17,3,7,0.85)',
                border: '1px solid rgba(215,175,185,0.18)',
                borderRadius: '50%',
                boxShadow: '0 4px 16px rgba(0,0,0,0.35)',
                color: '#EFE5DC',
                cursor: 'pointer',
                display: panelOpen ? 'none' : 'flex',
                height: '44px',
                justifyContent: 'center',
                left: '16px',
                position: 'fixed',
                top: '230px',
                transition: 'transform 0.15s, box-shadow 0.15s',
                width: '44px',
                zIndex: 10001
            } },
            React.createElement(ChatIcon, null),
            unreadCount > 0 && (React.createElement("span", { style: {
                    alignItems: 'center',
                    background: '#e55039',
                    borderRadius: '50%',
                    color: '#fff',
                    display: 'flex',
                    fontSize: '10px',
                    fontWeight: 700,
                    height: '18px',
                    justifyContent: 'center',
                    minWidth: '18px',
                    padding: '0 3px',
                    position: 'absolute',
                    right: '-4px',
                    top: '-4px'
                } }, unreadCount > 99 ? '99+' : unreadCount))),
        React.createElement(ChatPanel, { onClose: handleClose, open: panelOpen })));
};
export default ChatOverlay;
